import { render } from "./EsPinsLogo.vue?vue&type=template&id=dffd7a10"
import script from "./EsPinsLogo.vue?vue&type=script&lang=js"
export * from "./EsPinsLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__